export enum SessionsTabs {
  PENDING_REVIEW = 'pending_review',
  UPCOMING_PARTNERS = 'upcoming_partners',
  UPCOMING = 'upcoming',
  PAST = 'past'
}
